import React from 'react';

class StreamPreview extends React.Component {
	render () {
		return (
			<div className="col w80p txtmiddle col-medium-only">
				<a href={this.props.streamURL} 
					target="_blank" 
					className="streamPreview">
					<img src={this.props.streamPreviewImg} />
				</a>
			</div>
		);
	}
}

export default StreamPreview;